const hostMatches = (hostname, domain) => (
  hostname === domain || hostname.endsWith(`.${domain}`)
);

export function getLinkProvider(rawUrl) {
  if (!rawUrl) return 'generic';

  try {
    const hostname = new URL(rawUrl).hostname.toLowerCase();
    if (hostname === 'spotify.link' || hostname === 'open.spotify.com') {
      return 'spotify';
    }
    if (hostname === 'youtu.be' || hostMatches(hostname, 'youtube.com')) {
      return 'youtube';
    }
    if (hostMatches(hostname, 'instagram.com')) {
      return 'instagram';
    }
    if (
      hostname === 'localhost'
      || hostname === '127.0.0.1'
      || hostMatches(hostname, 'mindmappi.com')
    ) {
      const url = new URL(rawUrl);
      if (url.searchParams.get('map')) return 'mindmappi';
    }
  } catch {
    return 'generic';
  }

  return 'generic';
}

export function getLinkProviderLabel(provider, metadata, fallbackDomain) {
  if (provider === 'spotify') return 'Spotify';
  if (provider === 'mindmappi') return 'Mindmappi';
  return metadata?.siteName || fallbackDomain || 'Open link';
}
